import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { axiosGet, axiosPatch, axiosPost } from 'Redux/axiosHelper'
import {
  DefaultIconResp,
  DefaultIconType,
  DefualtIconPayload,
} from 'types/listing/listings'

const getDefaultIconByType = async (params: { iconFor: DefaultIconType }) => {
  const response = await axiosGet(`v1/default-icons/by-type`, params)
  return response.data
}

export const useGetDefaultIconByType = (params: {
  iconFor: DefaultIconType
}) => {
  const defaultIconByType = useQuery<DefaultIconResp>(
    ['default-icon-by-type'],
    () => getDefaultIconByType(params),
    { enabled: false },
  )
  return defaultIconByType
}

// default icon create
const createDefaultIcon = async (payload: DefualtIconPayload) => {
  const response = await axiosPost(
    payload,
    `v1/default-icons`,
    'Default icon added!',
  )
  return response.data
}
export const useCreateDefaultIcon = () => {
  const queryClient = useQueryClient()
  return useMutation(createDefaultIcon, {
    onSuccess: data => {
      queryClient.setQueryData(
        ['default-icon-by-type'],
        (oldData: DefaultIconResp | undefined) => {
          if (!oldData) return data
          return data
        },
      )
    },
  })
}

// update defualt icon
const updateDefaultIcon = async ({
  id,
  payload,
}: {
  id: string
  payload: DefualtIconPayload
}) => {
  const response = await axiosPatch(
    payload,
    `v1/default-icons/${id}`,
    'Icon updated successfully!',
  )
  return response.data
}

export const useUpdateDefaultIcon = () => {
  const queryClient = useQueryClient()
  return useMutation(updateDefaultIcon, {
    onSuccess: data => {
      queryClient.setQueryData(
        ['default-icon-by-type'],
        (oldData: DefaultIconResp | undefined) => {
          if (!oldData) return data
          return { ...oldData, ...data }
        },
      )
    },
  })
}
